import React from "react";
import { FiFacebook,  FiLinkedin } from "react-icons/fi";
import { SiFiverr, SiGithub } from "react-icons/si";
import hero from "../assets/images/my2.png";
import DownloadButton from "./DownloadButton";
const Hero = () => {
  const social_media = [
   
    {
      Component: FiFacebook,
      title: "FB",
      link: "https://www.facebook.com/7kumaaa/",
      size : 'text-3xl'

    },

    {
      Component: SiGithub,
      title: "GitHub",
      link: "https://github.com/usman-174",
      size : 'text-3xl'

    },

    {
      Component: FiLinkedin,
      title: "LinkedIn",
      link: "https://www.linkedin.com/in/usmanmughal174",
      size : 'text-3xl'

    },
    {
      Component: SiFiverr,
      title: "Fiverr",
      link: "https://www.fiverr.com/share/0vL6xA",
      size : 'text-5xl'

    },
  ];

  return (
    <section
      id="home"
      className="min-h-screen flex py-10 md:flex-row flex-col items-center"
    >
      <div className="flex-1 flex items-center justify-center h-full md:mx-0 mx-4 md:mb-20">
        <img
          src={hero}
          alt=""
          className="md:w-[90%] h-[90%] object-cover rounded-[50%]"
        />
      </div>
      <div className="flex-1">
        <div className="md:text-left text-center">
          <h1 className="md:text-5xl text-2xl md:leading-normal leading-10 text-white font-bold">
            <span className="text-cyan-600 md:text-6xl text-5xl">
              Hello!
              <br />
            </span>
            My Name is <span>Usman </span>
          </h1>
          <h4 className="md:text-2xl text-lg md:leading-normal leading-5 mt-4 font-bold text-gray-600">
            Fullstack Developer | PHP | JAVASCRIPT
          </h4>
          <div className="flex items-center gap-3 ">
            <button className="btn-primary mt-8">Contact Me</button>
            <DownloadButton />
          </div>
          <div className="mt-8 text-3xl flex items-center md:justify-start justify-center gap-5">
            {social_media?.map(({ Component, title, link ,size}) => (
              <div
                key={title}
                className={`${size} text-gray-600 hover:text-white cursor-pointer `}
              >
                <a href={link} target="_blank"
                rel="noreferrer"
                >
                  <Component />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
